module.exports = __webpack_public_path__ + "img/Bank.aece4177.svg";